var map = {
	"./Dave.png": "5c49",
	"./PhirePhox.png": "9d5a",
	"./RandoBoy.png": "345c",
	"./about.png": "f774",
	"./bg.png": "dc97",
	"./icon1.png": "ded3",
	"./icon2.png": "e82b",
	"./icon3.png": "b23c",
	"./icon4.png": "abea",
	"./logo.png": "4ffd",
	"./logo_.png": "b4cb",
	"./nfts.png": "4b94",
	"./phox1.png": "1376",
	"./phox2.png": "dad2",
	"./phox3.png": "883a",
	"./rinbow.png": "3d7a",
	"./stars-bg.png": "824e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";